import React from 'react';

import { Link } from 'react-router-dom';

import dummyAvatar from '@common/react/images/avatar.jpg';
import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import { Doctor } from '@commonTuna/react/objects/BaseDoctor';

interface Props {
	doctor: Doctor;
}

const ProviderInfo: React.FC<Props> = ({
	doctor,
}) => {
	const {
		nameEn,
		textEn,
		originalAvatar,
		averageReviewRate,
		totalReviewCount,
	} = doctor;
	return (
		<div className="provider-info clearfix">
			<div className="pull-left avatar-container">
				<ImageLazy
					className="avatar"
					height="100%"
					width="100%"
					alt="avatar"
					title={nameEn}
					src={originalAvatar ? `/remote/${originalAvatar}` : dummyAvatar}
				/>
			</div>
			<div className="is-relative provider-info__text">
				<h2>
					{nameEn}
					{typeof averageReviewRate !== 'undefined' && <div className="avg-rate">
						<span title="rate" className="stars ml10">
							{Array.from({ length: Math.round(+averageReviewRate || 0) }).map((_, i) => i)
								.map((i) => <i className="fa fa-star" key={i} aria-hidden="true" />)}
						</span>
						<span title="review count" className="review-count">
							(
							{+(totalReviewCount ?? 0)}
							)
						</span>
					</div>}
				</h2>
				<div dangerouslySetInnerHTML={{ __html: textEn }} />
				<Link className="article__link pull-right" to="/about">
					Meet the team
				</Link>
			</div>
		</div>
	);
};

export default ProviderInfo;
